"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import { useId } from 'react';
import clsx from 'clsx';
import styles from './NavigationGroup.module.scss.mjs';
import '../../../../lib/propsContext/propsContext.mjs';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../../../lib/propsContext/PropsContextProvider.mjs';
import { TunnelProvider, TunnelExit } from '@mittwald/react-tunnel';
import { Accordion } from '../../../Accordion/Accordion.mjs';
import { Content } from '../../../Content/Content.mjs';
import { flowComponent } from '../../../../lib/componentFactory/flowComponent.mjs';

const NavigationGroup = flowComponent("NavigationGroup", (props) => {
  const { children, className, collapsable, ...rest } = props;
  const rootClassName = clsx(
    styles.navigationGroup,
    collapsable && styles.collapsable,
    className
  );
  const generatedId = useId();
  const propsContext = {
    Label: {
      id: generatedId,
      className: styles.label,
      "aria-hidden": true
    },
    Link: {
      tunnelId: "groupLinks"
    }
  };
  if (collapsable) {
    return /* @__PURE__ */ jsx(PropsContextProvider, { mergeInParentContext: true, props: propsContext, children: /* @__PURE__ */ jsx(TunnelProvider, { children: /* @__PURE__ */ jsxs(Accordion, { defaultExpanded: true, className: rootClassName, children: [
      children,
      /* @__PURE__ */ jsx(Content, { clearPropsContext: false, children: /* @__PURE__ */ jsx("ul", { children: /* @__PURE__ */ jsx(TunnelExit, { id: "groupLinks" }) }) })
    ] }) }) });
  }
  return /* @__PURE__ */ jsx(PropsContextProvider, { mergeInParentContext: true, props: propsContext, children: /* @__PURE__ */ jsx(TunnelProvider, { children: /* @__PURE__ */ jsx(
    "section",
    {
      "aria-labelledby": generatedId,
      className: rootClassName,
      ...rest,
      children: /* @__PURE__ */ jsxs(PropsContextProvider, { mergeInParentContext: true, props: propsContext, children: [
        children,
        /* @__PURE__ */ jsx(TunnelExit, { id: "Label" }),
        /* @__PURE__ */ jsx("ul", { children: /* @__PURE__ */ jsx(TunnelExit, { id: "groupLinks" }) })
      ] })
    }
  ) }) });
});

export { NavigationGroup, NavigationGroup as default };
//# sourceMappingURL=NavigationGroup.mjs.map
